import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { LatestUpdates } from "@/components/landing/LatestUpdates";
import { WhyUs } from "@/components/landing/WhyUs";
import { Services } from "@/components/landing/Services";
import { Industries } from "@/components/landing/Industries";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Pricing } from "@/components/landing/Pricing";
import { ClientJourney } from "@/components/landing/ClientJourney";
import { Testimonials } from "@/components/landing/Testimonials";
import { KnowledgeCentre } from "@/components/landing/KnowledgeCentre";
import { FAQ } from "@/components/landing/FAQ";
import { CTABanner } from "@/components/landing/CTABanner";
import { Footer } from "@/components/landing/Footer";
import { ScrollProgress, WhatsAppFab } from "@/components/landing/Floating";
import SEO from "@/components/SEO";
import { getOrganizationSchema, getWebSiteSchema, getFAQPageSchema } from "@/lib/seoSchemas";
import { FAQS } from "@/lib/data";

export default function Landing() {
  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
    return () => clearTimeout(timer);
  }, []);

  const landingSchemas = [getOrganizationSchema(), getWebSiteSchema(), getFAQPageSchema(FAQS)].filter(Boolean);

  return (
    <div className="relative min-h-screen bg-white font-sans text-navy-900 antialiased" data-testid="landing-page">
      <SEO
        title="Biz360 Compliance | Business Registration, GST, Tax & ROC Compliance in India & Maharashtra"
        description="Expert-led business registration, GST filing, ROC compliance, accounting & corporate secretarial services across India with dedicated presence in Pune, Mumbai, Parbhani & Maharashtra."
        canonical="/"
        keywords="business registration India, company registration Pune, GST filing Maharashtra, ROC compliance Mumbai, Parbhani MSME registration, private limited company, LLP registration, Gumasta licence"
        schema={landingSchemas}
      />
      <ScrollProgress />
      <Navbar />
      <main>
        <LatestUpdates />
        <Hero />
        <WhyUs />
        <Services />
        <Industries />
        <EditorialMarquee />
        <Pricing />
        <ClientJourney />
        <Testimonials />
        <KnowledgeCentre />
        <FAQ />
        <CTABanner />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
